import { useRunPayrollDataContext } from 'components/RunPayroll/contexts/RunPayrollDataContext';
import permissions from 'constants/permissions';
import { useIsPayPtEnabled } from './useIsPayPtEnabled';
import useHasPermission from 'utils/useHasPermission';

export const useCanViewComplianceActions = () => {
  const data = useRunPayrollDataContext();
  const isAuthorizedToExecute = useHasPermission([permissions.PAYROLL_EXECUTION]);

  const isPayPtOnRunPayrollEnabled = useIsPayPtEnabled();

  // Gated on hasKaptPayments (via useIsPayPtEnabled) rather than on org-wide
  // payroll finalization: the backend only reports KA PT payments once there is
  // something to pay, and a single skipped employee is enough to make an
  // executed payroll read as un-finalized — which used to hide this card and
  // the Initiate CTA with it.
  return isPayPtOnRunPayrollEnabled && data ? isAuthorizedToExecute : false;
};
